export var PageCategoryTemplate;
(function (PageCategoryTemplate) {
    PageCategoryTemplate["Retail"] = "retail";
    PageCategoryTemplate["Service"] = "service";
    PageCategoryTemplate["Informative"] = "informative";
})(PageCategoryTemplate || (PageCategoryTemplate = {}));
//# sourceMappingURL=page-category-template.enum.js.map